module.exports = __webpack_public_path__ + "img/i_review_write.d6a18956.svg";